<template>
  <QuestionnaireBase :title="title" :form="form" :finishFunction="null">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "@/views/questionnaires/loadHelpers";
import {dateFormat} from "@/mixins/dateFormat";

import QuestionnaireBase from "../../../../components/common/questionnaires/questionnaire";
import FuneralDonor from "@/components/common/questionnaires/fieldsets/will/simple/funeral/FuneralDonor";
import FuneralTypeService from "@/components/common/questionnaires/fieldsets/will/simple/funeral/FuneralTypeService";
import FuneralWishes from "@/components/common/questionnaires/fieldsets/will/simple/funeral/FuneralWishes";

export default {
  name: "WillFuneral",
  mixins: [loadHelpers, dateFormat],
  components: {
    QuestionnaireBase,
    FuneralDonor,
    FuneralTypeService,
    FuneralWishes
  },
  data() {
    return {
      name: 'WillFuneral',
      title: "Will Funeral",
      url: 'will_full',
      order:
          [
            'FuneralTypeService',
            'FuneralDonor',
            'FuneralWishes'
          ],
      expiryAccessCodeOnFinish: true
    }
  }
};
</script>
